<img
  src="https://iforyou.ams3.cdn.digitaloceanspaces.com/WeDream.svg"
  alt="WeDream rules"
  class="logo-weDream"
  loading="lazy" 
/>
